"use strict";

// https://infra.spec.whatwg.org/#sets
//
// Only use this class if a Set cannot be used, e.g. when "replace" operation is needed, since there's no way to replace
// an element while keep the relative order using a Set, only remove and then add something at the end.
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
module.exports = /*#__PURE__*/function (_Symbol$iterator) {
  function OrderedSet() {
    _classCallCheck(this, OrderedSet);
    this._items = [];
  }
  _createClass(OrderedSet, [{
    key: "append",
    value: function append(item) {
      if (!this.contains(item)) {
        this._items.push(item);
      }
    }
  }, {
    key: "prepend",
    value: function prepend(item) {
      if (!this.contains(item)) {
        this._items.unshift(item);
      }
    }
  }, {
    key: "replace",
    value: function replace(item, replacement) {
      var seen = false;
      for (var i = 0; i < this._items.length;) {
        var isInstance = this._items[i] === item || this._items[i] === replacement;
        if (seen && isInstance) {
          this._items.splice(i, 1);
        } else {
          if (isInstance) {
            this._items[i] = replacement;
            seen = true;
          }
          i++;
        }
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
        items[_key] = arguments[_key];
      }
      this.removePredicate(function (item) {
        return items.includes(item);
      });
    }
  }, {
    key: "removePredicate",
    value: function removePredicate(predicate) {
      for (var i = 0; i < this._items.length;) {
        if (predicate(this._items[i])) {
          this._items.splice(i, 1);
        } else {
          i++;
        }
      }
    }
  }, {
    key: "empty",
    value: function empty() {
      this._items.length = 0;
    }
  }, {
    key: "contains",
    value: function contains(item) {
      return this._items.includes(item);
    }
  }, {
    key: "size",
    get: function get() {
      return this._items.length;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._items.length === 0;
    }

    // Useful for other parts of jsdom
  }, {
    key: _Symbol$iterator,
    value: function value() {
      return this._items[Symbol.iterator]();
    }
  }, {
    key: "keys",
    value: function keys() {
      return this._items.keys();
    }
  }, {
    key: "get",
    value: function get(index) {
      return this._items[index];
    }
  }, {
    key: "some",
    value: function some(func) {
      return this._items.some(func);
    }

    // https://dom.spec.whatwg.org/#concept-ordered-set-parser
  }, {
    key: "serialize",
    value:
    // https://dom.spec.whatwg.org/#concept-ordered-set-serializer
    function serialize() {
      return this._items.join(" ");
    }
  }], [{
    key: "parse",
    value: function parse(input) {
      var tokens = new OrderedSet();
      var _iterator = _createForOfIteratorHelper(input.split(/[\t\n\f\r ]+/)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var token = _step.value;
          if (token) {
            tokens.append(token);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return tokens;
    }
  }]);
  return OrderedSet;
}(Symbol.iterator);